import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { GistProvider } from './contexts/GistContext'
import Layout from './components/Layout'
import SplitView from './components/SplitView'
import GistList from './components/GistList'
import GistDetail from './components/GistDetail'

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: (
          <>
            <div className="lg:hidden">
              <GistList />
            </div>
            <div className="hidden lg:block">
              <SplitView />
            </div>
          </>
        ),
      },
      {
        path: ':id',
        element: (
          <>
            <div className="lg:hidden">
              <GistDetail />
            </div>
            <div className="hidden lg:block">
              <SplitView />
            </div>
          </>
        ),
      },
    ],
  },
], { basename: '/gists' })

export default function App() {
  return (
    <GistProvider>
      <RouterProvider router={router} />
    </GistProvider>
  )
}
